export const TRANSLATION_URL = '/translation/v1/machine_translations/translate';
